import React from 'react'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'

type CurrentWorkspaceContext = WorkspaceMinimalFragment

export const currentWorkspaceContext = React.createContext<
  CurrentWorkspaceContext | undefined
>(undefined)
